import React, { useEffect, useRef } from "react";
import { validateNumber } from "../../helper/common";

const PriceChangeColored = ({ value, isColor = true }) => {
  const prevValueRef = useRef(null);
  const timeoutRef = useRef(null); // to clear old timeouts
  const spanRef = useRef(null); // for class manipulation

  useEffect(() => {
    if (
      isColor &&
      value &&
      prevValueRef.current !== null &&
      value !== prevValueRef.current
    ) {
      const classToAdd =
        value > prevValueRef.current
          ? "text_animated-up"
          : "text_animated-down";

      // Clear previous timeout if any
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }

      if (spanRef.current) {
        spanRef.current.classList.remove(
          "text_animated-up",
          "text_animated-down"
        );
        spanRef.current.classList.add(classToAdd);

        timeoutRef.current = setTimeout(() => {
          spanRef.current?.classList.remove(
            "text_animated-up",
            "text_animated-down"
          );
          timeoutRef.current = null;
        }, 800);
      }
    }

    prevValueRef.current = value;
  }, [value, isColor]);

  return (
    <div className="price-container text-end" ref={spanRef}>
      {/* <span className="text_span">{value ? validateNumber(value) : ""}</span> */}
      <span className="text_span">{value === null ? "" : value}</span>
    </div>
  );
};

export default PriceChangeColored;
